module.exports = __webpack_public_path__ + "img/96.5ccee139.webp";